module.exports = __webpack_public_path__ + "static/media/e-school.1f0117dd.jpg";